export default function (num: number | undefined, places = 0) {
  if (num === undefined) return undefined;
  const offset = Math.pow(10, places);
  return Math.round(num * offset) / offset;
}
